import { useQuery } from "@tanstack/react-query";
import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export type UsageOperation = {
  id: number;
  name: string;
};

const useUsageOperations = () => {
  const userToken = useAuth()?.userToken!;

  return useQuery<UsageOperation[]>([ENDPOINTS.usage_operations], () =>
    fetch(ENDPOINTS.usage_operations, {
      method: "GET",
      headers: jsonAuthHeaders(userToken),
    }).then(handleResponse),
  );
};

export { useUsageOperations };
